module.exports = __webpack_public_path__ + "images/payconiq.9327cfe4474c3edfd6dae2f81f8a7247.svg";